// Fixed initial state — same as Puzzleship's daily puzzle on 2026-08-13.
// Each sub-array is a plate, index 0 = bottom, last = top.
// 3 colors (a, b, c) × 4 balls each = 12 balls in 3 filled plates + 2 empty.

import type { GameState } from "./logic"

export const INITIAL_STATE: GameState = [
	["c", "b", "a", "b"],
	["a", "a", "b", "a"],
	["b", "c", "c", "c"],
	[],
	[],
]
